import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoMercado from "../servicios/InfoMercado";
const Footer = lazy(() => import('../footer/Footer'));
function MercadoValores() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="En Hyundai nos preocupamos por tu seguridad."
        />
        <meta name="keywords" content="mercado, valores, Hyundai" />
        <title>Mercado de valores | Hyundai</title>
      </Helmet>
      <Menu />
      <InfoMercado />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default MercadoValores;